import React from 'react'
import { LinkType } from '@sidecar-components/atoms/Link'

export enum ButtonSentiment {
  PRIMARY = 'primary',
  PRIMARY_ON_COLOR = 'primaryOnColor',
  SECONDARY = 'secondary',
  SECONDARY_ON_COLOR = 'secondaryOnColor',
  ACCENT = 'accent',
  NOTIFY = 'notify',
  RISK = 'risk',
  HIGH_RISK = 'highRisk',
  LINK = 'link',
  LINK_ON_COLOR = 'linkOnColor',
  SIDEKICK = 'sidekick',
  STARTER = 'starter',
}

export enum ButtonSize {
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large',
}

type BaseButtonProps = {
  busy?: boolean
  className?: string
  disabled?: boolean
  iconPosition?: 'before' | 'after'
  linkComponent?: React.ComponentType<any>
  onClick?: any
  path?: string
  pathType?: LinkType
  sentiment?: ButtonSentiment
  size?: ButtonSize
  testId?: string
  type?: React.ButtonHTMLAttributes<HTMLButtonElement>['type']
  width?: string
}

type ButtonWithChildren = BaseButtonProps & {
  children: string
  label?: string
  icon?: string
}

type ButtonWithLabel = BaseButtonProps & {
  children?: never
  label: string
  icon: string // required when only label is provided
}

type ButtonWithBoth = BaseButtonProps & {
  children: string
  label: string
  icon?: string
}

export type ButtonProps = ButtonWithChildren | ButtonWithLabel | ButtonWithBoth

export interface ButtonStyleProps {
  busy?: boolean
  children?: string
  disabled?: boolean
  icon?: string
  sentiment?: ButtonSentiment
  size?: ButtonSize
  width?: string
}
